import UIManager from "../../Shared/UIManager";
import NetworkLogic from "../../Shared/NetworkLogic";
import RechargeInfoUI from "./RechargeInfoUI";
import AudioManager from "../../Shared/AudioManager";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class RechargeRecordsUI extends cc.Component {
    @property(cc.Prefab)
    pfbRechargeInfoLayer: cc.Prefab = null

    @property(cc.Node)
    nodeTemplateItem: cc.Node = null

    @property(cc.Node)
    nodeContent: cc.Node = null

    private _page: number = 1

    start() {
        this.nodeTemplateItem.parent = null
        this.getRecordsFromServer()
    }

    onDestroy() {
        this.nodeTemplateItem.destroy()
    }

    onBtnClick(event, userData) {
        if (userData === "close") {
            AudioManager.playSound("close")
            this.node.destroy()
        } else if (userData === "info") {
            UIManager.showLoadingUI()
            NetworkLogic.getRecordDetail(event.target.parent["recordID"], function (data) {
                UIManager.hideLoadingUI()
                let rechargeInfoUI = cc.instantiate(this.pfbRechargeInfoLayer).getComponent(RechargeInfoUI)
                rechargeInfoUI.node.parent = this.node
                rechargeInfoUI.money = data.money
                rechargeInfoUI.order = data.orderNumber
                rechargeInfoUI.date = data.createTime
                rechargeInfoUI.type = data.type
                rechargeInfoUI.state = data.status
            }.bind(this))
        }
    }

    onScrollEvent(scrollView, eventType) {
        if (eventType === cc.ScrollView.EventType.SCROLL_TO_BOTTOM) {
            this.getRecordsFromServer()
        }
    }

    private getRecordsFromServer() {
        UIManager.showLoadingUI()
        NetworkLogic.getRecord(this._page, 10, function (data) {
            UIManager.hideLoadingUI()
            data.length > 0 && this._page++
            this.createItems(data)
        }.bind(this))
    }

    private createItems(records) {
        let states = [i18n.t('pre_details_text.succ'), i18n.t('pre_details_text.error'), i18n.t('pre_details_text.audit'), i18n.t('pre_details_text.czSucc')]
        let colors = [cc.color(74, 190, 139), cc.color(190, 74, 74), cc.color(190, 190, 74), cc.color(190, 74, 74)]

        records.forEach(item => {
            let node = cc.instantiate(this.nodeTemplateItem)
            node["recordID"] = item.id
            node.getChildByName("time").getComponent(cc.Label).string = item.createTime
            node.getChildByName("state").color = colors[parseInt(item.status)]
            node.getChildByName("state").getComponent(cc.Label).string = states[parseInt(item.status)]
            node.getChildByName("money").getComponent(cc.Label).string = item.chargeMoney
            node.parent = this.nodeContent
        });
    }
}
